import React from 'react';
import { ContextBasedGeneratorJob, QuestionGeneratorJob, TopicBasedGeneratorJob } from '../../../../../../utils/types/content_manager_types';
import { QuestionsList } from '../../../../upload_file/question_list';
import styles from './document_details.module.css';

type DocumentDetailsProps = {
    job: TopicBasedGeneratorJob | ContextBasedGeneratorJob,
    updateJob: (newJobData: QuestionGeneratorJob) => void,
}

export const DocumentDetails = ({
  job,
  updateJob,
}: DocumentDetailsProps) => {
  const sourceText = 'transcript' in job && job.transcript ? job.transcript : job.topic || '';
  const transcriptPreview =
    sourceText.length > 900 ? `${sourceText.slice(0, 900).trim()}...` : sourceText;
  const wordCount = sourceText.trim() ? sourceText.trim().split(/\s+/).length : 0;
  const jobTitle = typeof job.settings?.jobTitle === 'string'
    ? job.settings.jobTitle
    : job.settings?.jobTitle?.jobTitle;

  return (
    <div
        className={styles.documentDetailsContainer}
    >
      <div className={styles.summaryGrid}>
        <div className={styles.summaryCard}>
          <span className={styles.summaryLabel}>Source</span>
          <strong>{ 'filename' in job && job.filename ? job.filename : job.topic || 'Topic based generation' }</strong>
        </div>
        <div className={styles.summaryCard}>
          <span className={styles.summaryLabel}>Generated Questions</span>
          <strong>{ job.questions?.length || 0 }</strong>
        </div>
        <div className={styles.summaryCard}>
          <span className={styles.summaryLabel}>Question Type</span>
          <strong>{ job.settings?.questionType || 'Not set' }</strong>
        </div>
        <div className={styles.summaryCard}>
          <span className={styles.summaryLabel}>Job Title</span>
          <strong>{ jobTitle || 'Not selected' }</strong>
        </div>
      </div>

      { sourceText && (
        <section className={styles.transcriptContainer}>
          <div className={styles.sectionHeader}>
            <div>
              <h3>Transcript Preview</h3>
              <p>{ wordCount } words extracted from this content.</p>
            </div>
            <span>{ job.generationType }</span>
          </div>
          <p className={styles.transcriptText}>
            { transcriptPreview }
          </p>
        </section>
      ) }

      <QuestionsList
          job={job}
          setJob={updateJob}
          errorJob={false}
          questionsLoading={false}
      />
    </div>
  );
};
